import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { Alert } from '@mui/material';

import { ThemeButton } from '../../../../ui'
import { INPUTS_CONFIG, FORM_CONFIG } from './campaign-form.constants'
import { GridForm } from './grid-form.component'
import { useCampaignsContext } from '../../contexts'
import { useCombos } from '../../../combos/hooks'
import { useCampaginsValidations } from '../../hooks'
import { prepareCampaignDto } from './campaign-form.utils'

export const CampaignsCreateForm = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const combos = useCombos(['gremios'])
  const cnaes = useCombos(['cnae'])
  const arrayCnae = Array.isArray(cnaes?.cnae) ? cnaes.cnae : (cnaes?.cnae?.data || []);
  const { createCampaign } = useCampaignsContext()
  const { formErrors } = useCampaginsValidations()

  const [formState, setFormState] = useState({
    activa: true,
    financiacion: '00',
    origen: 'instalador',
    is_op: false,
    tipo_gas: 'GAS_NATURAL',
    tiempograbacion: 0,
  })
  const [loading, setLoading] = useState(false)
  const [errorMssg, setErrorMssg] = useState('')

  const handleChangeForm = (e) => {
    if (e.target.name === 'origen') {
      eraseGremiosAndProvsFields(e)
    } else {
      setFormState({ ...formState, [e.target.name]: e.target.value })
    }
  }

  const eraseGremiosAndProvsFields = (e) => {
    delete formState.comunidades
    delete formState.cnae
    formState.is_op = false
    setFormState({ ...formState, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const errors = formErrors(formState)
    if (!errors) {
      setLoading(true)

      createCampaign(prepareCampaignDto(formState))
        .then((data) => {
          setLoading(false)
          navigate(`/campaigns/${data.id}`)
        })
        .catch(() => {
          setLoading(false)
        })
    } else {
      setErrorMssg(errors)
    }
  }
  const INPUTS = INPUTS_CONFIG({
    data: formState,
    combos,
    cnaeData: arrayCnae,
    intl,
    onChange: handleChangeForm,
    readOnly: false,
  })

  return (
    <form onSubmit={handleSubmit}>
      <Box display="flex" mt={2} mb={2} justifyContent="flex-end">
        <ThemeButton type="submit" color="primary" loading={loading}>
          {intl.formatMessage({
            id: `pages.campaigns.create.button.save.label`,
          })}
        </ThemeButton>
      </Box>
      {errorMssg ? <Alert severity="error">{errorMssg}</Alert> : null}
      <GridForm {...{ grid: FORM_CONFIG, inputs: INPUTS }} />
    </form>
  )
}
